import "../../Privacy/Privacy.scss";
import "../../../components/Delivery/Delivery.scss";
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer";
import { Helmet } from "react-helmet";
import crumbs from "../../../icons/icons8-home.svg";
import forward_arrow from "../../../icons/icons-forward-arrow.png";
import { Link } from "react-router-dom";

export default function paymentDelivery() {
    return (
        <div className="privacy">
            <Helmet>
                <meta
                    name="keywords"
                    content="Обмін та повернення, Санберрі Україна"
                />
                <title>Публічна оферта від компанії Санберрі Україна</title>
                <link rel="canonical" href="https://sun-ukr.com/obmin-ta-povernennya" />
                <meta
                    name="description"
                    content="Інформація, наведена на сайті, є довідковою. Обмін та повернення ТОВ «Санберрі Україна» міститься за посиланням: https://sun-ukr.com/obmin-ta-povernennya"
                ></meta>
            </Helmet>
            <Header />
            <div className="crumbs">
                <Link className="crumbs__link" to="/">
                    <img className="crumbs__logo" src={crumbs} alt="crumbs" />
                </Link>
                <img className="crumbs__arrow" src={forward_arrow} alt="forward-arrow" />
                <span className="crumbs__text">Обмін та повернення</span>
            </div>
            <div className="privacy__container">
                <h1 className="privacy__title">Обмін та повернення</h1>
                <div className="paymentDelivery__block">
                    <b><p className="paymentDelivery__headline">Обмін та повернення товару в Санберрі Україна 🔄</p></b>
                    <p className="paymentDelivery__caption">
                        Компанія Санберрі Україна прагне забезпечити найкращий сервіс для своїх клієнтів, тому ми пропонуємо зручні умови обміну та повернення товарів. Ми цінуємо вашу довіру та гарантуємо високу якість насіння, добрив і засобів захисту рослин, які реалізуємо. Якщо з будь-якої причини вам необхідно обміняти або повернути товар, ми зробимо це швидко та без зайвих труднощів.
                    </p>
                    <b><p className="paymentDelivery__headline">Умови повернення та обміну товару</p></b>
                    <p className="paymentDelivery__caption">
                        🔹 Обмін або повернення можливе протягом 14 днів із моменту отримання товару, згідно з Законом України «Про захист прав споживачів».
                    </p>
                    <p className="paymentDelivery__caption">
                        🔹 Товар має бути непошкодженим, у заводському пакуванні, з усіма супровідними документами.
                    </p>
                    <p className="paymentDelivery__caption">
                        🔹 Поверненню або обміну не підлягають товари, які були відкриті, використані або пошкоджені покупцем.
                    </p>
                    <p className="paymentDelivery__caption">
                        🔹 Якщо товар має виробничий дефект або не відповідає замовленню, ми гарантуємо безкоштовну заміну або повернення коштів.
                    </p>
                    <b><p className="paymentDelivery__headline">Як здійснити обмін або повернення?</p></b>
                    <p className="paymentDelivery__caption">
                        ✅ Крок 1: Зв’яжіться з нами за телефоном 📞 або через e-mail ✉, вказавши причину повернення.
                    </p>
                    <p className="paymentDelivery__caption">
                        ✅ Крок 2: Підготуйте товар до відправки – він має бути в оригінальному пакуванні, без пошкоджень.
                    </p>
                    <p className="paymentDelivery__caption">
                        ✅ Крок 3: Надішліть товар зручним для вас способом (Нова Пошта, Укрпошта тощо).
                    </p>
                    <p className="paymentDelivery__caption">
                        ✅ Крок 4: Після перевірки товару ми оформимо повернення коштів або обмін на аналогічний товар.
                    </p>
                    <b><p className="paymentDelivery__headline">Гарантія якості та відповідальність</p></b>
                    <p className="paymentDelivery__caption">
                        Компанія Санберрі Україна співпрацює лише з перевіреними виробниками та постачальниками. Ми гарантуємо якість продукції, але якщо у вас виникли питання чи зауваження щодо товару – ми завжди готові допомогти!
                    </p>
                    <p className="paymentDelivery__caption">
                        📞 Телефонуйте або пишіть нам – ми знайдемо оптимальне рішення для вас! 🤝 🚛
                    </p>
                </div >
            </div >
            <Footer />
        </div >
    );
}
